export default "__VITE_ASSET__D00F_bcX__"